var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, makeObservable } from 'mobx';
export class TrayBar {
    parent;
    isDragHovering = false;
    selectedCycleIndex;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get tray() {
        return this.parent;
    }
    get app() {
        return this.parent.app;
    }
    get cycleInBar() {
        if (typeof this.selectedCycleIndex !== 'undefined') {
            return this.tray.trayCycles.allCycles[this.selectedCycleIndex];
        }
        return this.app.cycle;
    }
}
__decorate([
    observable
], TrayBar.prototype, "isDragHovering", void 0);
__decorate([
    observable
], TrayBar.prototype, "selectedCycleIndex", void 0);
